export default "/images/thumbs-up.svg?b429fdfeed5479b1300f14e1bdabc087";